import React, { useState } from 'react'
import { useStore } from '../../StateProvider'
import { TierForm } from '../TierForm/TierForm'
import { useTranslation } from 'react-i18next'
import {
  additionalFldValues,
  filterByTier
} from '../ExternalFields'
import { Page } from '../../ui/Page/Page'

const Tier3Form = ({
  onSent
}) => {
  const { t } = useTranslation()
  const [{
    whitelabel,
    form,
    form: { accId }
  }] = useStore()
  const { extFields } = whitelabel
  const [isLoading, setIsLoading] = useState(false)

  const fldsDescriptionList = filterByTier(3)(extFields)

  const onSubmit = () => {
    setIsLoading(true)
    return onSent(additionalFldValues(form[accId])(fldsDescriptionList))
  }

  return (
    <Page caption={t('tier3Upgrade.formTitle')} text={t('tier3Upgrade.formText')}>
      <TierForm
        isLoadingSubmit={isLoading}
        onSubmit={onSubmit}
        buttonName={t('tier3Upgrade.done')}
      />
    </Page>
  )
}

export { Tier3Form }
